import { useEffect, useRef, useState } from "react";

interface GoogleMapProps {
  latitude: number;
  longitude: number;
  address?: string;
  className?: string;
}
export const ApiKeyMaps = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || "AIzaSyDZbQdb1BYay10U4Ymk5Xm5Kh7zF35jn8w";
export const GoogleMap = ({ latitude, longitude, address, className = "" }: GoogleMapProps) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<google.maps.Map | null>(null);
  const [mapError, setMapError] = useState<string | null>(null);

  useEffect(() => {
    console.log('GoogleMap useEffect - checking conditions:', {
      hasMapRef: !!mapRef.current,
      hasWindow: !!window,
      hasGoogle: !!(window as any).google,
      hasGoogleMaps: !!(window as any).google?.maps,
      latitude,
      longitude,
      address
    });

    if (!mapRef.current) {
      console.log('GoogleMap: No map ref available');
      return;
    }

    if (!(window as any).google) {
      console.log('GoogleMap: Google not loaded on window');
      setMapError('Google Maps não foi carregado');
      return;
    }

    if (!(window as any).google.maps) {
      console.log('GoogleMap: Google Maps not available');
      setMapError('Google Maps API não está disponível');
      return;
    }

    try {
      console.log('GoogleMap: Initializing map with coordinates:', latitude, longitude);
      
      // Initialize the map
      mapInstanceRef.current = new (window as any).google.maps.Map(mapRef.current, {
        center: { lat: latitude, lng: longitude },
        zoom: 16,
        mapTypeId: (window as any).google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false,
        zoomControl: true,
        streetViewControl: true,
        fullscreenControl: true,
      });

      // Add marker
      new (window as any).google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map: mapInstanceRef.current,
        title: address || "Endereço selecionado",
      });

      console.log('GoogleMap: Map initialized successfully');
      setMapError(null);
    } catch (error) {
      console.error('GoogleMap: Error initializing map:', error);
      setMapError(`Erro ao inicializar o mapa: ${error}`);
    }
  }, [latitude, longitude, address]);

  if (mapError) {
    return (
      <div className={`w-full h-64 rounded-lg border border-gray-200 bg-red-50 flex items-center justify-center ${className}`}>
        <div className="text-center text-red-600">
          <p className="font-medium">Erro ao carregar o mapa</p>
          <p className="text-sm mt-1">{mapError}</p>
          <p className="text-xs mt-2">API Key: {ApiKeyMaps.substring(0, 10)}...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`w-full h-64 rounded-lg border border-gray-200 overflow-hidden ${className}`}>
      <div ref={mapRef} className="w-full h-full" />
    </div>
  );
};

// Load Google Maps script
export const loadGoogleMapsScript = (apiKey: string = ApiKeyMaps) => {
  return new Promise<void>((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      console.log('Google Maps script loaded successfully');
      resolve();
    };
    script.onerror = (error) => {
      console.error('Failed to load Google Maps script:', error);
      reject(new Error('Failed to load Google Maps script'));
    };
    
    document.head.appendChild(script);
  });
};